import React from 'react';
import { siteData } from '../mock/data';

const Marquee = () => {
  const items = ['Property Management', 'Immobilienverwaltung', 'Werterhalt', 'Strategisch', 'Digital', 'Verlässlich', 'Düsseldorf', 'Family Offices'];
  const all = [...items, ...items, ...items];
  return (
    <section className="ticker-divider py-8 overflow-hidden bg-[#F5F1EA]">
      <div className="marquee-track">
        {all.map((t, i) => (
          <div key={i} className="flex items-center gap-10 px-10 whitespace-nowrap">
            <span className="font-display text-5xl md:text-6xl text-[#0A2A28]">{t}</span>
            <span className="w-2 h-2 rounded-full bg-[#BFA070]" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
